// Persisted to localStorage and passed to buildPalette(), so values must match the family
// and tier keys in app/tokens.js.
import { BrightnessHigh, BrightnessLow, BrightnessMedium } from '@mui/icons-material';

export const THEME_MODES = ['light', 'dark', 'system'];

export const TIER_OPTIONS = [
  { value: 'dim', label: 'Dim', icon: BrightnessLow },
  { value: 'mid', label: 'Mid', icon: BrightnessMedium },
  { value: 'bright', label: 'Bright', icon: BrightnessHigh },
];

// A copy of the family keys (shared/ can't import app/); tokens.test.js asserts they match.
// Alphabetical: the default comes from tokens.js, not list position.
export const LIGHT_THEME_OPTIONS = [
  { value: 'cool', label: 'Cool' },
  { value: 'fern', label: 'Fern' },
  { value: 'mauve', label: 'Mauve' },
  { value: 'pewter', label: 'Pewter' },
  { value: 'rose', label: 'Rose' },
  { value: 'sand', label: 'Sand' },
];

export const DARK_THEME_OPTIONS = [
  { value: 'clay', label: 'Clay' },
  { value: 'ember', label: 'Ember' },
  { value: 'graphite', label: 'Graphite' },
  { value: 'moss', label: 'Moss' },
  { value: 'orchid', label: 'Orchid' },
  { value: 'slate', label: 'Slate' },
];
